import useVoice from '../../hooks/useVoice';
import styles from './VoiceMicButton.module.css';

/**
 * VoiceMicButton — click to enter voice mode.
 *
 * Only renders in text mode (not connected). Once connected,
 * ChatInput shows the voice status panel instead.
 */
export default function VoiceMicButton({ disabled }) {
  const { voiceState, voiceError, isVoiceConnected, connectVoice } = useVoice();

  // Already connected — don't render (voice panel shown in ChatInput)
  if (isVoiceConnected) return null;

  // Connecting spinner
  if (voiceState === 'connecting') {
    return (
      <button className={`${styles.micButton} ${styles.connecting}`} disabled title="Connecting...">
        <span className={styles.connectingInner}>
          <MicIcon className={styles.icon} />
        </span>
      </button>
    );
  }

  // Default: click to connect
  return (
    <button
      className={`${styles.micButton} ${styles.connectBtn}`}
      onClick={connectVoice}
      disabled={disabled}
      title="Switch to voice"
    >
      <MicIcon className={styles.icon} />
      {voiceError && <span className={styles.errorTooltip}>{voiceError}</span>}
    </button>
  );
}

function MicIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="1" width="6" height="12" rx="3" />
      <path d="M5 10a7 7 0 0 0 14 0" />
      <line x1="12" y1="17" x2="12" y2="21" />
      <line x1="8" y1="21" x2="16" y2="21" />
    </svg>
  );
}
